import { flatten } from 'lodash-es'

const getTagName = (tagCategories, tagUrlId) => {
  const tagsList = (tagCategories || []).map(
    (classification) => classification.tags
  )
  const tag = flatten(tagsList).find((tag) => tag.urlId === tagUrlId)
  return tag?.name || ''
}

export const getAllFiltersName = (tagCategories, filters = []) => {
  return filters
    ?.map((tagUrlId) => getTagName(tagCategories, tagUrlId))
    .filter((name) => name)
}

export const getFiltersNameString = (...args) => {
  const names = getAllFiltersName(...args)
  return (names || []).join(', ')
}
